export const accountSettingPageText = {
    cancelModalTitle: '변경하지 않고 나갈까요?',
    cancelModalContent: '지금 나가시면, 계정 설정이 변경되지 않고 원래대로 유지됩니다.',
    cancleModalFirstButton: '나가기',
    cancleModalSecondButton: '머무르기',
};
